export const RISK_HIGH_COLOR = '#FFA9A9';
export const RISK_MEDIUM_COLOR = '#FFF5A9';
export const RISK_LOW_COLOR = '#A9FFC6';

export const factoryCategoryColorMap = {
    LOW: '#A9FFC6',
    MEDIUM: '#FFF5A9',
    HIGH: '#FFA9A9',
    SLIGHT: '#e7eb7a',
    MILD: '#f7d75c',
    MODERATE: '#ff9e58',
    SEVERE: '#ff6b6b',
    NONE: '#84f3b5',
};

export const tremorIndexColorMap = {
    0: '#e7eb7a',
    1: '#f7d75c',
    2: '#ff9e58',
    3: '#ff6b6b',
    4: '#84f3b5',
};
